import Container from '@material-ui/core/Container';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// import TextField from '@material-ui/core/TextField';
import React from 'react';
import { AfterPageProps, wrapLayout } from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';

export type DownloadsPageProps = AfterPageProps;
export type DownloadsPageClassNameKey = 'root';

const useStyles = makeStyles((theme: Theme) =>
  createStyles<DownloadsPageClassNameKey, {}>({
    root: {
      paddingTop: '150px',
      paddingBottom: '150px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1),
      },
    },
  }),
);

const DownloadsPage: React.FC<DownloadsPageProps> = () => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.root}>
          <h1>Ke stažení</h1>

          <h2>Zde je místo pro dokumenty a jiné soubory ke stažení.</h2>
        </div>
      </Container>
    </>
  );
};

DownloadsPage.displayName = 'DownloadsPage';

export default wrapLayout(DownloadsPage, InfoLayout);
